"use client";

import React, { useState } from "react";
import FadeIn from "../ui/FadeIn";

const faqs = [
  {
    question: "What is being a local advisor?",
    answer:
      "A Local Advisor is a verified resident who provides personalized, real-time travel recommendations and guidance to travelers visiting their city.",
  },
  {
    question: "How much I can earn?",
    answer:
      "Your earnings depend on the services you provide and the number of travelers you assist. There is no cap on how much you can earn.",
  },
  {
    question: "What are the benefits of being an advisor?",
    answer:
      "Benefits include flexible working hours, the ability to work from anywhere, earning extra income, and sharing your passion for your city with global travelers.",
  },
  {
    question: "Can I work with my current job?",
    answer:
      "Yes, you can work as an advisor alongside your current job. You choose your own schedule and availability.",
  },
  {
    question: "Is this work from anywhere?",
    answer:
      "Yes, as long as you have first-hand knowledge of the local area and high-speed internet, you can respond to travelers from anywhere.",
  },
  {
    question: "Can I choose my own schedule?",
    answer:
      "Absolutely. You are in control of when you are active and available to help travelers.",
  },
  {
    question: "Can I withdraw money into my bank account?",
    answer:
      "Yes, once you provide services and earn money, you can securely withdraw it into your verified bank account.",
  },
  {
    question: "What about tax reporting?",
    answer:
      "As a service provider, you are responsible for reporting and paying your own taxes based on your local regulations and income.",
  },
];

export default function AdvisorFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="px-4 py-16 md:py-24 bg-[#E5F7F6] mx-auto max-w-7xl">
      <div className=" px-4 md:px-24">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-20">
          <div className="max-w-full lg:max-w-[80%] ">
            <FadeIn direction="right">
              <h2 className=" text-4xl font-base leading-tight text-[#0A2B1C] md:text-5xl">
                Your Question Answered
              </h2>
              <p className="mt-6 text-[#403F3C] md:text-sm lg:max-w-[80%]">
                Have questions about Salesflow? Here are some of the most common
                queries to help you.
              </p>
              <p className="mt-4 text-sm text-[#403F3C] lg:max-w-[70%]">
                Can’t find the answer you’re looking for?{" "}
                <a
                  href="/contact"
                  className="font-semibold text-[#51CBBE] underline"
                >
                  Contact us
                </a>{" "}
                for more questions.
              </p>
            </FadeIn>
          </div>

          <div>
            <div className="space-y-4">
              {faqs.map((faq, index) => {
                const isOpen = openIndex === index;
                return (
                  <FadeIn
                    key={index}
                    direction="up"
                    delay={0.1 * index}
                    className="rounded-xl border border-[#D7DDE2] bg-white overflow-hidden transition-all duration-300 hover:border-[#063B66]/50 group"
                  >
                    <div
                      onMouseEnter={() => setOpenIndex(index)}
                      className="cursor-pointer"
                    >
                      <button
                        onClick={() => toggleFAQ(index)}
                        className="flex w-full items-center justify-between p-5 text-left focus:outline-hidden"
                      >
                        <span className="pr-4 text-[16px] font-semibold text-[#0A2B1C] transition-colors group-hover:text-[#063B66]">
                          {faq.question}
                        </span>
                        <span className="ml-4 flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-[#B0B0B0]">
                          <svg
                            className={`transform transition-transform duration-300 ${isOpen ? "rotate-180" : "rotate-0 text-[#063B66]"}`}
                            width="12"
                            height="8"
                            viewBox="0 0 12 8"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M1 1L6 6L11 1" />
                          </svg>
                        </span>
                      </button>
                      <div
                        className={`overflow-hidden transition-all duration-500 ease-in-out ${
                          isOpen
                            ? "max-h-96 pb-5 px-5 opacity-100"
                            : "max-h-0 opacity-0"
                        }`}
                      >
                        <p className="text-sm leading-6 text-[#403F3C]">
                          {faq.answer}
                        </p>
                      </div>
                    </div>
                  </FadeIn>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
